import { render, staticRenderFns } from "./bidderFlow.vue?vue&type=template&id=50216030&scoped=true"
import script from "./bidderFlow.vue?vue&type=script&lang=js"
export * from "./bidderFlow.vue?vue&type=script&lang=js"
import style0 from "./bidderFlow.vue?vue&type=style&index=0&id=50216030&prod&lang=less&scoped=true"
import style1 from "./bidderFlow.vue?vue&type=style&index=1&id=50216030&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50216030",
  null
  
)

export default component.exports